import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { StockRoomListComponent } from './stock-room-list/stock-room-list.component';

@NgModule({
  declarations: [StockRoomListComponent],
  imports: [SharedModule],
  exports: [StockRoomListComponent],
})
export class StockRoomListModule { }
